import { AppSettings, AppSettingsDataClient } from '@24i/nxg-sdk-photon';
import { RuntimeConfig } from '@24i/nxg-core-utils/src/globalSingletons';
import deepmerge from 'deepmerge';

export const getServiceConfig = async (client: AppSettingsDataClient) => {
    const result = await client.fetchServiceConfig();
    const runtimeFeatures = RuntimeConfig.get()?.features || {};
    return deepmerge<AppSettings>({ features: runtimeFeatures }, result, {
        arrayMerge: (d, s) => s,
    });
};
